"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * Columns component.
 *
 * This is the container for the columns, or in terms of HTML, it is the
 * wrapping `<ul>` element. You specify a list of `ColumnItem` components as
 * the children, and it will flow them into the correct columns based on the
 * props passed in.
 *
 * @class Columns
 * @public
 */
class Columns extends _react.Component {
  /**
   * Create the columns in a horizontal direction for the supplied items.
   *
   * @param {Array} items items to render into columns
   * @param {Number} num the number of columns to make
   * @returns {Array} columns
   * @api private
   */
  horizontal(items, num) {
    const columns = [];
    let i;
    for (i = 0; i < num; i++) {
      columns[i] = [];
    }
    for (i = 0; i < items.length; i++) {
      columns[i % num].push(items[i]);
    }
    return columns;
  }

  /**
   * Create the columns in a vertical direction for the supplied items.
   *
   * @param {Array} items items to render into columns
   * @param {Number} num the number of columns to make
   * @returns {Array} columns
   * @api private
   */
  vertical(items, num) {
    const itemsPerColumn = Math.ceil(items.length / num);
    const columns = [];
    let i;
    for (i = 0; i < num; i++) {
      const start = i * itemsPerColumn;
      const end = start + itemsPerColumn;
      columns[i] = items.slice(start, end);
    }
    return columns;
  }

  /**
   * Render the component.
   *
   * @returns {ReactElement} div
   * @api public
   */
  render() {
    const props = _objectSpread({
      num: 4,
      style: 'vertical'
    }, this.props);
    const {
      num,
      style
    } = props;
    const children = _react.default.Children.toArray(props.children);
    const className = (0, _classnames.default)('column', props.className);
    const columns = this[style](children, num);
    if (!columns || columns.length === 0) {
      return null;
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "column-layout",
      style: {
        '--cols': num
      }
    }, columns.map((items, idx) => {
      return /*#__PURE__*/_react.default.createElement("ul", {
        className: className,
        key: idx
      }, items);
    }));
  }
}

/**
 * Property definitions.
 *
 * @type {Object}
 * @public
 */
Columns.propTypes = {
  num: _propTypes.default.number,
  style: _propTypes.default.oneOf(['horizontal', 'vertical']),
  className: _propTypes.default.string,
  children: _propTypes.default.arrayOf(_propTypes.default.node)
};
var _default = exports.default = Columns;